import {
  deleteSelectResource
} from "@/redux/slices/resources/ResourceSlice";
import {
  AppointmentByTimeRangeInfo,
  IAppointmentByTimeRangeRequest,
  IResourceService,
  ResourceInfo,
  TokenIResourceService
} from "@/services";
import { Dispatch } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import ResourceSelected from ".";
import { FORMAT_DATE_DEFAULT, TimeFunction } from "@/common/datetime/TimeFunction";
import { SearchResponse } from "@/fetchInterceptor/AxiosMethod";
import { baContainer } from "@/ioc";

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  const resourceService: IResourceService = baContainer.resolve(
    TokenIResourceService
  );
  return {
    deleteSelectResource: (resourceInfo: ResourceInfo) => {
      dispatch(deleteSelectResource(resourceInfo));
    },
    onFetchAppointmentsByTimeRange: (
      tenantId: string,
      currentDate: Date,
      resourceIds: string[]
    ): Promise<AppointmentByTimeRangeInfo[]> => {
      const req: IAppointmentByTimeRangeRequest = {
        CalendarIds: resourceIds,
        StartDate: `${TimeFunction.dateTimeFormatter(
          currentDate,
          FORMAT_DATE_DEFAULT
        )}T00:00:00.000Z`,
        EndDate: `${TimeFunction.dateTimeFormatter(
          currentDate,
          FORMAT_DATE_DEFAULT
        )}T23:59:59.000Z`,
      };
      return resourceService
        .fetchAppointmentsByTimeRange(tenantId, req)
        .then((resp: SearchResponse<AppointmentByTimeRangeInfo>) => resp.data);
    },
  };
};

export default connect(null, mapDispatchToProps)(ResourceSelected);
